export interface TIconsLabel {
		[key: string]: {
				icon: string,
				name: string
		}
}

export const iconsLabelSchedulingAppraisal: TIconsLabel = {
		scheduling: {
				icon: 'assets/images/m1',
				name: 'EM AGENDAMENTO'
		},
		notScheduled: {
				icon: 'assets/images/m3',
				name: 'CADASTRADAS'
		},
		scheduled: {
				icon: 'assets/images/m2',
				name: 'AGENDADA'
		}
}
